<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title=this.setSectionTitle()
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>

          </el-tooltip>
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('create_action')">
              <button
                type="button"
                class="btn btn-primary btn-with-shadow"
                data-toggle="modal"
                @click="createjob">
                {{ $t("create_job") }}
              </button>
          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_management") }}</h5>
          <p class="mb-0">{{ $t("introduction_job") }}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("edit") }} :</strong> {{ $t("edit_action") }}</li>
            <li><strong>{{ $t("duplicate") }} :</strong> {{ $t("duplicate_action") }}</li>
            <li><strong>{{ $t("bid") }} :</strong> {{ $t("bid_action") }}</li>
            <li><strong>{{ $t("job_management") }} :</strong> {{ $t("job_management_action") }}</li>

          </ul>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div
          class="p-primary align-items-center primary-card-color border-bottom"
        >
          <ul
            class="nav tab-filter-menu d-inline-flex justify-content-flex-end"
          >
            <li
              class="nav-item"
              v-for="(item, index) in userFilterOptions"
              :key="index"
            >
              <a
                href="#"
                class="nav-link font-size-default py-0"
                :class="[
                  filteredData.status == item.id
                    ? 'active'
                    : index === 0 && filteredData.status === ''
                    ? 'active'
                    : '',
                ]"
                @click.prevent="getFilterValue(item.id)"
              >
                {{ item.value }}
              </a>
            </li>
          </ul>
          <div class="float-right">
            <app-search @input="getSearchValue" />
          </div>
        </div>
      </div>
    </div>
    <!-- <job-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    /> -->

    <app-table
      :id="tableId"
      :options="options"
      :search="search"
      :card-view="false"
      @action="getListAction"
      :filtered-data="filteredData"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../core/helpers/app/AppFunction";
import { axiosGet } from "../../../../../Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  props: {
    active: Object,
    customerCompanyId: Number,
    sectionTitle: String,
  },
  data() {
    return {
      // isAddEditModalActive: false,
      instructionShow: false,
      check: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      filteredData: {
        status: "",
      },
      search: "",
      tableId: "job-management-index",
      rowData: {},
      options: {
        // cardView: true,
        // cardViewComponent: "grid-view",
        name: this.$t("tab_filter"),
        url: this.getActionUrl(),
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          // {
          //   title: this.$t("job"),
          //   type: "media-object",
          //   key: "media-object",
          //   mediaTitleKey: "title",
          //   mediaSubtitleKey: "location",
          //   default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
          //   modifier: (value, row) => {
          //     return value; // imag url
          //   },
          //   isVisible: true,
          // },
          {
            title: this.setSectionTitle(),
            type: "custom-html",
            key: "title",
            isVisible: true,
            modifier: (value,row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("end_date"),
            type: "custom-html",
            key: "end_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("is_private"),
            type: "custom-html",
            key: "is_private",
            modifier: (value) => {
              let type = 'Private';

              if (value == 0) {
                type = 'Public';
              }
              return `<span>${this.$t(type)}</span>`;
            },
          },
          {
            title: this.$t("type"),
            type: "custom-html",
            key: "job_type",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value, row) => {
              let ClassName = "warning";


              const date1 = new Date(row.end_date);
              const date2 = new Date();
              // One day in milliseconds
              const oneDay = 1000 * 60 * 60 * 24;
              // Calculating the time difference between two dates
              const diffInTime = date1.getTime() - date2.getTime();
              // Calculating the no. of days between two dates
              const diffInDays = Math.round(diffInTime / oneDay);

              if (value === "active") ClassName = `success`;
              else if (value === "inprogress") ClassName = `dark`;
              else if (value === "completed") ClassName = `primary`;
              else if (diffInDays <= 0) {ClassName = `danger`};


              let statusValue = diffInDays <= 0? 'Due' : value;
              let StatusClass = diffInDays <= 0? 'danger' :ClassName;
              if (value == 'job-template') {
                  statusValue = value;
                  StatusClass = `warning`;
              }

              return `<span class="text-capitalize badge badge-sm badge-pill badge-${StatusClass}">${this.$t(
                  statusValue
              )}</span>`;
            },
          },
          {
              title: this.$t('bid_counts'),
              type: 'custom-html',
              key: 'assigned_bid_form',
              modifier: (value) => {
                let count = value.length > 0 ? value[0].accepted_forms.length :'Bidform not assign';

                  return `<span>`+count+`</span>`
              }
          },
          {
            title: this.$t("created_at"),
            type: "custom-html",
            key: "created_at",
            modifier: (value) => {
              var date = moment(value).format("YYYY-MM-DD hh:mm");
              return `<span>${this.$t(date)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            // component: "app-add-modal",
            // modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            // component: "app-add-modal",
            // modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("duplicate"),
            icon: "copy",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },
          {
            title: this.$t("bid"),
            icon: "bid",
            type: "none",
          },
          {
            title: this.setManagementTitle(),
            icon: "clipboard",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All Jobs" },
        { id: "active", value: "Active" },
        { id: "inprogress", value: "Inprogress" },
        { id: "draft", value: "Draft" },
        { id: "completed", value: "Completed" },
        { id: "job-template", value: "Template" },
      ],
    };
  },

  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  mounted(){
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('status') == true) {
        let status = urlParams.get('status');
        this.getFilterValue(status);
    }
    setTimeout(() => {
      this.customerAction();
    }, 5000);
  },
  methods: {
    setManagementTitle(){
      let title = this.sectionTitle?'Contract Management':'job_management';
      return this.$t(title);
    },
    setSectionTitle(){
      let title = this.sectionTitle??'jobs';
      return this.$t(title);
    },
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;

      this.$hub.$emit("reload-" + this.tableId);
    },
    createjob() {
      // window.location = "/buyer/job/create";
      this.active = 2
      this.$emit('createJob',this.active);
    },
    myFunction(id){
      let doc = document.getElementById(id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(id)
        }) 
      }
    },
    view(id) {
        // this.check = true;
        console.log("view");
        this.active = 4
        this.$emit('jobId',id,this.active);
    },
    // closeAddEditModal() {
    //   this.isAddEditModalActive = false;
    //   this.reSetData();
    // },

    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("duplicate")) {
        this.duplicateJob(rowData.id);
      } else if (actionObj.title == this.$t("edit")) {
        // window.location = "job/edit/" + rowData.id;
        this.active = 3
        this.$emit('jobId',rowData.id,this.active);
      } else if (actionObj.title == this.$t("job_management") || actionObj.title == this.$t("Contract Management")) {

        this.active = 4
        this.$emit('jobId',rowData.id,this.active);
      }
      if (actionObj.title == this.$t("bid")) {
        // window.location = "job/bid/" + rowData.id;
        this.active = 5
        this.$emit('jobId',rowData.id,this.active);
      }
      if (actionObj.title == this.$t("delete")) {
        this.deleteJob(rowData)
      }
      // else if (actionObj.title == this.$t("chat")) {
      //   if (rowData.status == 'inprogress')
      //   {
      //     window.location = "/buyer/job/chat/"+ rowData.id;
      //   }
      //   else
      //   {
      //     this.$toastr.s('Chat allow only inprogress jobs');
      //   }
      // }
    },
    async deleteJob(rowData) {
      // Display confirmation dialog
      const confirmed = window.confirm('Are you sure you want to delete this job?');
      const jobId = rowData.id;
      if (!confirmed) {
        return;
         // If user cancels, exit the function
      }

      try {
        // Make the delete request using Axios
        const response = await axios.delete(`/company-jobs/${jobId}`);
        this.$hub.$emit("reload-" + this.tableId);
        // Handle successful deletion
        this.$toastr.s(response.data.message);

        // Optionally, perform any other actions after successful deletion
      } catch (error) {
        // Handle errors
        this.$toastr.e(error.response.data.message);

        // Optionally, display an error message to the user
      }

    },
    duplicateJob(id) {
      let customerCompanyId = this.customerCompanyId;
      if (customerCompanyId){
        id += '/' + customerCompanyId;
      }
      let url = actions.JOB_DUPLICATE+'/'+id;
      this.preLoader = true;
      axiosGet(url)
        .then((response) => {
          // $("#demo-delete").modal("hide");
          // this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });

    },

    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );
        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    getActionUrl() {
      let customerCompanyId = this.customerCompanyId;
      let url = actions.COMPANY_JOBS
      if(customerCompanyId){
        url = actions.COMPANY_JOBS + '/' + this.customerCompanyId
      }
      return url;
    },
    customerAction() {
      let role = this.userRole.role;
      console.log(role);
      if (role == "Customer" || role == "customer") {
        this.options.actions = [
        {
            title: this.setManagementTitle(),
            icon: "clipboard",
            type: "none",
          },
      ]
      }
    },
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },

};
</script>
